// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradientStyle {
    align-self: flex-start;
}

.picker {
    margin: 5px 0px;
}

.gradientStopControl > .gradientPreview {
    position: relative;
    margin: 4px;
    height: 20px;
    width: 200px;
}

    .gradientStopControl > .gradientPreview > p-slider {
        width: 200px;
        position: absolute;
        top: 50%;
        left: 0px;
    }

/*::ng-deep .gradientStopControl p-slider .ui-slider {
    height: 0px;
}

::ng-deep .gradientStopControl p-slider .ui-slider-handle {
    background: inherit;
    clip-path: polygon(50% 0%, 100% 40%, 100% 100%, 0% 100%, 0% 40%);
}

::ng-deep .gradientStopControl p-slider.selectedStop .ui-slider-handle {
    background: rgb(250, 237, 2);
}*/

.hexStack {
    padding: 4px;
}

.hexBlock {
    width: 85px;
}

.rgbBlock {
    width: 45px;
    margin-right: 5px;
}

.overlay {
    z-index: 20;
}

/*::ng-deep .mcc-color-picker-selector-preview {
    display: none;
}*/`, "",{"version":3,"sources":["webpack://./src/app/components/controls/gradientpicker/gradientpicker.control.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;IAEI;QACI,YAAY;QACZ,kBAAkB;QAClB,QAAQ;QACR,SAAS;IACb;;AAEJ;;;;;;;;;;;EAWE;;AAEF;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;;EAEE","sourcesContent":[".gradientStyle {\n    align-self: flex-start;\n}\n\n.picker {\n    margin: 5px 0px;\n}\n\n.gradientStopControl > .gradientPreview {\n    position: relative;\n    margin: 4px;\n    height: 20px;\n    width: 200px;\n}\n\n    .gradientStopControl > .gradientPreview > p-slider {\n        width: 200px;\n        position: absolute;\n        top: 50%;\n        left: 0px;\n    }\n\n/*::ng-deep .gradientStopControl p-slider .ui-slider {\n    height: 0px;\n}\n\n::ng-deep .gradientStopControl p-slider .ui-slider-handle {\n    background: inherit;\n    clip-path: polygon(50% 0%, 100% 40%, 100% 100%, 0% 100%, 0% 40%);\n}\n\n::ng-deep .gradientStopControl p-slider.selectedStop .ui-slider-handle {\n    background: rgb(250, 237, 2);\n}*/\n\n.hexStack {\n    padding: 4px;\n}\n\n.hexBlock {\n    width: 85px;\n}\n\n.rgbBlock {\n    width: 45px;\n    margin-right: 5px;\n}\n\n.overlay {\n    z-index: 20;\n}\n\n/*::ng-deep .mcc-color-picker-selector-preview {\n    display: none;\n}*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
